<template>
  <select v-model="selected">
    <option :value="null"></option>
    <option
      v-for="(groupName, index) of groupNames"
      :key="index"
      :value="groupName"
    >
        {{ `${groupName}` }}
    </option>
  </select>
</template>

<script lang="ts">
import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator'
import _ from 'lodash';

@Component
export default class GroupNameInput extends Vue {
  @Prop() value!: string

  @Prop() groupNames!: []

  private get selected(): string|null {
    return this.value || null
  }

  private set selected(groupName: string|null) {
    this.$emit('input', groupName)
  }
}
</script>

<style scoped>
  select{
    padding: 5px;
    border: 1px solid #AAAFB6;
    border-radius: 30px;
    width: 100%;
  }
</style>
